<div>
  <!-- Header -->
  <div class="flex items-end justify-between gap-[14px] mb-[22px]">
    <div>
      <p class="text-[25px] font-bold leading-tight mb-[6px] text-surface-700 dark:text-surface-300">
        {{ title }}
      </p>

      <p class="text-[13px] leading-tight text-surface-400 dark:text-surface-300 ">
        {{ subtitle }}
      </p>
    </div>
    <ng-content select="[page-actions]"></ng-content>

    <!-- Optional right-side header actions -->
    <ng-content select="[header-actions]"></ng-content>
  </div>

  <!-- Card Content -->
  <p-card>
    <div class="flex items-center justify-between gap-2 mb-3 ">

      <!-- Left toolbar -->
      <div class="flex items-center gap-2">
        <ng-content select="[toolbar-left]"></ng-content>
      </div>

      <!-- Right toolbar -->
      <div class="flex items-center gap-2 ">
        <ng-content select="[toolbar-right]"></ng-content>
      </div>

    </div>

    <div class="card ">
      <ng-content></ng-content>
    </div>
  </p-card>

</div>
